import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Search } from 'lucide-react';

const SEOSection = ({ keywords }) => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 mb-4">
              <Search className="w-6 h-6 text-teal-600" />
              <h2 className="text-3xl sm:text-4xl font-bold text-slate-900">
                Find Us Online
              </h2>
            </div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Search for expert pediatric hematology and oncology care in Hyderabad
            </p>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <Card className="p-8 sm:p-10 border-slate-200 shadow-lg">
            <h3 className="text-xl font-bold text-slate-900 mb-6 text-center">
              Search Keywords
            </h3>
            <div className="flex flex-wrap gap-3 justify-center">
              {keywords?.map((keyword, idx) => (
                <Badge
                  key={idx}
                  variant="outline"
                  className="px-4 py-2 text-sm border-teal-300 text-slate-700 hover:bg-teal-50 hover:border-teal-400 transition-colors cursor-default"
                >
                  {keyword}
                </Badge>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default SEOSection;